export default "__VITE_ASSET__BmemvBYF__"